import { format, parse } from 'date-fns';

export function formatDayMonth(locale: string, date: Date) {
  const formatter = new Intl.DateTimeFormat(locale, {
    day: '2-digit',
    month: 'long',
  });
  return formatter.format(date);
}

export function formatBuilderDate(dateString: string) {
  const withoutTimezoneName = dateString.split('(')[0].trim();
  const dateOnly = withoutTimezoneName.split(' ').slice(0, 4).join(' ');
  return format(parse(dateOnly, 'EEE LLL d yyyy', new Date()), 'yyyyMMdd');
}
